module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00000.6501aee0.png";